export const DEFAULT_TEXT_COLOR = '#5c738c';
